"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldPolyfill = void 0;
/**
 * https://bugs.chromium.org/p/chromium/issues/detail?id=1097432
 */
function hasMissingICUBug() {
    if (Intl.DisplayNames) {
        var regionNames = new Intl.DisplayNames(['en'], {
            type: 'region',
        });
        return regionNames.of('CA') === 'CA';
    }
    return false;
}
function shouldPolyfill() {
    return !Intl.DisplayNames || hasMissingICUBug();
}
exports.shouldPolyfill = shouldPolyfill;
